import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const modules = [{
  title: '📚 MÓDULO 1: Cómo funcionan en tu cuerpo',
  items: ['Qué hacen las hormonas', 'Los 3 mecanismos de acción', 'Tipos de píldoras explicados', 'Cuál es mejor para ti'],
  badge: null
}, {
  title: '⏰ MÓDULO 2: Cómo tomarlas correctamente',
  items: ['Las 5 reglas de oro', 'Cuándo y cómo empezar', 'Cómo almacenarlas bien', 'Errores más comunes'],
  badge: null
}, {
  title: '🚨 MÓDULO 3: ¿Y si olvido una dosis?',
  items: ['Árbol de decisión visual', 'Guía por semana del ciclo', 'Qué hacer con vómitos', 'Interacciones con medicamentos'],
  badge: {
    text: 'EL MÁS PEDIDO',
    color: 'bg-brand-accent text-white'
  }
}, {
  title: '💜 MÓDULO 4: Efectos secundarios reales',
  items: ['Qué es normal vs alarmante', 'Mitos vs Realidad', 'Señales de alerta ACHES', 'Cuándo llamar al médico'],
  badge: null
}, {
  title: '🌸 MÓDULO 5: Beneficios que no conocías',
  items: ['Más allá de la anticoncepción', 'Acné, SOP, endometriosis', 'Ciclos más regulares', 'Cómo aprovecharlos'],
  badge: null
}, {
  title: '📅 MÓDULO 6: Sistema de seguimiento',
  items: ['Calendarios 3 meses imprimibles', 'Checklists diarios y semanales', 'Tracker de síntomas 6 meses', 'Sistema de recompensas y rachas'],
  badge: {
    text: 'BONUS ESPECIAL',
    color: 'bg-brand-primary text-white'
  }
}];
export function Modules() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-148">
      <div className="text-center mb-16" data-id="element-149">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-dark" data-id="element-150">
          Todo lo que encuentras dentro:
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-151">
        {modules.map((mod, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-white rounded-[16px] p-8 shadow-md border border-brand-cardPink/50 relative overflow-hidden" data-id="element-152">
            {mod.badge && <div className={`absolute top-4 right-4 text-xs font-bold px-3 py-1 rounded-full ${mod.badge.color}`} data-id="element-153">
                {mod.badge.text}
              </div>}
            <h3 className="text-xl font-bold text-brand-dark mb-6 pr-24 leading-snug" data-id="element-154">
              {mod.title}
            </h3>
            <ul className="space-y-4" data-id="element-155">
              {mod.items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-156">
                  <Check className="w-5 h-5 text-brand-success shrink-0 mt-0.5" data-id="element-157" />
                  <span className="text-brand-secondary font-medium" data-id="element-158">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>)}
      </div>
    </section>;
}